module.exports = __webpack_public_path__ + "img/40_38_051_580.2bfa5190.jpg";